import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { setIsLoadingPopupOpened } from '../../../redux/features/general/navigation';
import CancelButton from '../inputs/CancelButton';

interface Props { 

}; 

const LoadingPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsLoadingPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    maxWidth: isMobile ? '80vw' : '300px',
                    width: '100%',
                    padding: isMobile ? 2 : 3, 
                    borderRadius: 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >

                <CircularProgress 
                    size={40} 
                    sx={{ marginTop: 1 }}
                />

                <Box
                    sx={{ 
                        width: '90%',
                        marginTop: 2, 
                        marginBottom: 1 
                    }}
                >{t('loading')}...

                </Box>

            </Box>

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Box>

  );

};

export default LoadingPopup;